import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, EditIcon, PaperclipIcon, CheckCircleIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockPOs } from '../data/mockData';
import { PurchaseOrder } from '../types';
export function PurchaseOrderList() {
  const navigate = useNavigate();
  const [attachments, setAttachments] = useState<Record<string, string>>({});
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [activePoId, setActivePoId] = useState<string | null>(null);
  const handleAttachClick = (poId: string) => {
    setActivePoId(poId);
    fileInputRef.current?.click();
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && activePoId) {
      setAttachments(prev => ({
        ...prev,
        [activePoId]: file.name
      }));
    }
    e.target.value = '';
    setActivePoId(null);
  };
  const columns: Column<PurchaseOrder>[] = [{
    key: 'poNo',
    label: 'PO No',
    render: po => <span className="font-medium text-indigo-600" data-id="element-1567">{po.poNo}</span>
  }, {
    key: 'linkedPRNo',
    label: 'Linked PR'
  }, {
    key: 'vendor',
    label: 'Vendor'
  }, {
    key: 'department',
    label: 'Dept'
  }, {
    key: 'totalAmount',
    label: 'Total Amount',
    render: po => <span className="font-medium" data-id="element-1568">${po.totalAmount.toLocaleString()}</span>
  }, {
    key: 'status',
    label: 'Status',
    render: po => <StatusBadge status={po.status} data-id="element-1569" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-1570">
      <div className="flex items-center justify-between" data-id="element-1571">
        <div data-id="element-1572">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1573">Purchase Orders</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1574">
            Manage and track purchase orders.
          </p>
        </div>
        <button onClick={() => navigate('/purchase-orders/create')} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1575">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-1576" />
          New PO
        </button>
      </div>

      <input type="file" ref={fileInputRef} onChange={handleFileChange} className="hidden" accept=".pdf,.doc,.docx,.jpg,.png" data-id="element-1577" />

      <div className="flex-1" data-id="element-1578">
        <DataTable columns={columns} data={mockPOs} keyExtractor={item => item.id} searchPlaceholder="Search POs..." onRowClick={item => navigate(`/purchase-orders/${item.id}/edit`)} actions={item => <div className="flex items-center space-x-3 justify-end" data-id="element-1580">
              <button onClick={() => navigate(`/purchase-orders/${item.id}/edit`)} className="text-indigo-600 hover:text-indigo-900" title="Edit" data-id="element-1581">
                <EditIcon className="h-4 w-4" data-id="element-1582" />
              </button>
              {attachments[item.id] ? <button onClick={() => handleAttachClick(item.id)} className="inline-flex items-center px-2 py-1 text-xs font-medium rounded-md text-green-700 bg-green-50 border border-green-200 hover:bg-green-100 transition-colors" title={`Agreement: ${attachments[item.id]}`} data-id="element-1583">
                  <CheckCircleIcon className="h-3.5 w-3.5 mr-1" data-id="element-1584" />
                  {attachments[item.id].length > 15 ? attachments[item.id].substring(0, 15) + '...' : attachments[item.id]}
                </button> : <button onClick={() => handleAttachClick(item.id)} className="inline-flex items-center px-2 py-1 text-xs font-medium rounded-md text-gray-600 bg-gray-50 border border-gray-200 hover:bg-gray-100 transition-colors" title="Attach Agreement" data-id="element-1585">
                  <PaperclipIcon className="h-3.5 w-3.5 mr-1" data-id="element-1586" />
                  Agreement
                </button>}
            </div>} data-id="element-1579" />
      </div>
    </div>;
}